// utils
import { formatTimeToString } from './formatDateToString';

// libraries
import dayjs from 'dayjs';

export const EXCEL_TYPE =
  'application/vnd.ms-excel;application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

export const addComma = (num) => {
  if (!num) return 0;

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const addZero = (text) => {
  const txt = text.toString();
  if (txt.length > 1) return text;
  return '0' + text;
};

export const addHyphen = (phoneNum) => {
  if (!phoneNum) return '';

  if (phoneNum.length === 8) {
    return phoneNum.replace(/^(\d{4})(\d{4})$/, `$1-$2`);
  }

  if (phoneNum.length === 10) {
    return phoneNum.replace(/^(\d{2})(\d{4})(\d{4})$/, `$1-$2-$3`);
  }

  return phoneNum.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
};

export const removeHyphen = (phoneNum) => {
  if (!phoneNum) return '';
  return phoneNum.replace(/-/g, '');
};

export const convertDataUrlToExcel = (excel) => {
  const blob = new Blob([excel], {
    type: EXCEL_TYPE
  });

  return new File([blob], excel.name, {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
};

export const hexToRgb = (hex) => {
  // Remove the hash (#) character if it's included
  hex = hex.replace(/^#/, '');

  // Parse the hex string into an integer
  const bigint = parseInt(hex, 16);

  // Extract the RGB values
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Return the RGB values as an object
  return { r, g, b };
};

export const getRandomNumber = (min, max, includeDecimal = false) => {
  if (includeDecimal) {
    // 소수점을 포함한 랜덤 숫자 생성
    return Math.random() * (max - min) + min;
  } else {
    // 정수형 랜덤 숫자 생성
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
};

/**
 * tableIndexCalculator : 각 페이지당 10개의 행이 표시된다고 가정할 때, 현재 페이지에 해당하는 행의 위치를 보정. 각 페이지마다 10개의 행이 줄어듦.
 * @param {*} total
 * @param {*} index
 * @param {*} page
 * @returns
 */
export const tableIndexCalculator = (total, index, page) => {
  return total - index - 10 * page;
};

/**
 * tableIndexCalculatorPerPage : 각 페이지 행 개수를 rowsPerPage 값으로 지정.
 * @param {*} total
 * @param {*} index
 * @param {*} rowsPerPage
 * @param {*} page
 * @returns
 */
export const tableIndexCalculatorPerPage = (total, index, rowsPerPage, page) => {
  return total - index - rowsPerPage * page;
};

export const findMenuByPathname = (menus, pathname) => {
  const findDirectly = menus.find((menu) => menu.menu === pathname);

  if (findDirectly) return findDirectly;

  for (const menu of menus) {
    if (Array.isArray(menu.subMenus)) {
      const found = findMenuByPathname(menu.subMenus, pathname);
      if (found) return found;
    }
  }

  return null;
};

export const findMenuByMenuId = (menus, menuId) => {
  const findDirectly = menus.find((menu) => menu.menuId === menuId);

  if (findDirectly) return findDirectly;

  for (const menu of menus) {
    if (Array.isArray(menu.subMenus)) {
      const found = findMenuByMenuId(menu.subMenus, menuId);

      if (found) return found;
    }
  }

  return null;
};

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const isDomainContaining = (subString, part = 'href') => {
  if (!subString) return false;

  const urlPart = window.location[part];

  return urlPart && urlPart.includes(subString);
};

export const wait = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
